import { Link } from "react-router-dom";
import { SeoHead } from "../../seo/SeoHead";
import { buildBreadcrumbListJsonLd } from "../../seo/site";

const SEO_DESCRIPTION =
  "Mentions légales du site Raguia : éditeur, hébergement OVH, propriété intellectuelle, droit applicable.";

export default function LegalPage() {
  return (
    <>
      <SeoHead
        title="Mentions légales — Raguia"
        description={SEO_DESCRIPTION}
        jsonLd={buildBreadcrumbListJsonLd([
          { name: "Accueil", path: "/" },
          { name: "Mentions légales", path: "/mentions-legales" },
        ])}
      />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
      <h1 className="font-heading text-3xl font-semibold tracking-tight text-[#010101] sm:text-4xl">
        ⚖️ Mentions légales
      </h1>
      <p className="mt-2 text-sm font-medium text-stone-800">
        Dernière mise à jour : avril 2026
      </p>

      <article className="prose prose-stone mt-10 max-w-none prose-headings:font-semibold prose-headings:text-[#010101] prose-p:text-stone-800 prose-li:text-stone-800 prose-a:text-[#A43032] prose-a:font-semibold prose-strong:text-[#010101]">
        <h2>Éditeur du site</h2>
        <p>
          Le site « Raguia » est édité par{" "}
          <strong>Valentin Fiess</strong>.
        </p>
        <ul className="not-prose mt-4 list-none space-y-1 pl-0 text-sm sm:text-base">
          <li>
            <strong>Siège social :</strong> 34470 Perols, France
          </li>
          <li>
            <strong>Contact :</strong> via le{" "}
            <Link to="/contact" className="font-medium text-[#A43032] hover:underline">
              formulaire de contact
            </Link>
          </li>
          <li>
            <strong>Directeur de la publication :</strong> Valentin Fiess
          </li>
          <li>
            <strong>SIREN / SIRET :</strong>
          </li>
        </ul>

        <h2>Hébergement</h2>
        <p>
          Le Site est hébergé par <strong>OVH SAS</strong>, 2 rue Kellermann, 59100 Roubaix,
          France —{" "}
          <a href="https://www.ovhcloud.com/fr/" target="_blank" rel="noopener noreferrer">
            ovhcloud.com
          </a>
          .
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          Les éléments du Site (textes, visuels, structure) sont protégés. Toute reproduction
          non autorisée est interdite.
        </p>

        <h2>Limitation de responsabilité</h2>
        <p>
          L’éditeur s’efforce d’assurer l’exactitude des informations. Les engagements
          contractuels sont formalisés dans les devis et contrats signés avec les clients.
        </p>

        <h2>Loi applicable</h2>
        <p>
          Droit français. Tribunaux français compétents, sous réserve des règles
          impératives applicables.
        </p>
      </article>

      <p className="mt-10">
        <Link to="/" className="text-sm font-medium text-[#A43032] hover:underline">
          ← Retour à l’accueil
        </Link>
      </p>
    </main>
    </>
  );
}
